'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createQueryParamString = require('../utils/createQueryParamString');

var _createQueryParamString2 = _interopRequireDefault(_createQueryParamString);

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _locationOrigin = require('./locationOrigin');

var _locationOrigin2 = _interopRequireDefault(_locationOrigin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Build a link (usually within the product, or back to signup ) based on the following parameters
 *
 * @param nextLink the relative path (without the domain) to send to, example `/dashboard/something`
 * @param extraQueryParams eventually extra param to be carried with the final URL
 * @param goToProduct flag for specific scenario to jump directly into product and clean all params
 * @returns {string}
 */
function makeLinkWithQueryParams(nextLink) {
  var extraQueryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var goToProduct = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var params = _QueryParamsContainer2.default.getJS();
  Object.keys(extraQueryParams).forEach(function (key) {
    params[key] = extraQueryParams[key];
  });

  if (!extraQueryParams.redirect) {
    delete params.redirect;
  }

  if (!extraQueryParams.intent) {
    delete params.intent;
  }

  if (goToProduct) {
    // clear params, leave only via ...
    Object.keys(params).filter(function (paramKey) {
      return !Object.keys(extraQueryParams).includes(paramKey);
    }).forEach(function (toRemove) {
      delete params[toRemove];
    });
  }

  var paramsString = (0, _createQueryParamString2.default)(params);

  var hasOriginInUrl = nextLink.indexOf('//') !== -1;

  return '' + (hasOriginInUrl ? '' : _locationOrigin2.default) + nextLink + (paramsString ? '?' + paramsString : '');
}

exports.default = makeLinkWithQueryParams;
module.exports = exports['default'];